import { DEPARTMENTS } from '../enums/enums';
import { InventoryQueryOptions } from '../inventory/inventory.interfaces';

export interface AHDeptPermissions {
	[DEPARTMENTS.CM]: boolean;
	[DEPARTMENTS.PR]: boolean;
	[DEPARTMENTS.SET]: boolean;
}

export interface AHDeptPermissionsResponse extends AHDeptPermissions {
	franchiseId: number;
}

export interface AHExportPayload {
	epItemIds: number[];
	epPropIds: number[];
	setPieceIds: number[];
	photoSelections: {
		continuity: boolean;
		establishing: boolean;
	};
	queryOptions?: InventoryQueryOptions;
}
